import { useRouter } from "next/router";
import { useState, useRef } from "react";
import environment from "../../../config/environment";
import styles from "./styles.module.scss";
import Search from "../../../public/static-next/search.svg";
import { gaEvents } from "../../../utils/ga_events";
import Link from "next/link";

export interface componentTypes {
  items: Array<Item>;
}
interface Item {
  name: string;
  slug?: string;
  link?: string;
  databaseId: number;
}

export const NavigationBlog = ({ items }: componentTypes) => {
  const toggleSearch = useRef<HTMLFormElement>(null);
  const [navExpand, setNavExpand] = useState<boolean>(false);
  const [mobileSearch, setMobileSearch] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<string>("");

  const router = useRouter();

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    gaEvents.blog.search(searchData);
    router.push(`${environment.basePath}/?s=${searchData}`);
  };

  const toogleSearchInput = () => {
    if (
      !toggleSearch.current.style.display ||
      toggleSearch.current.style.display == "none"
    ) {
      setMobileSearch(true);
      toggleSearch.current.style.display = "flex";
    } else {
      setMobileSearch(false);
      toggleSearch.current.style.display = "none";
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.wrap}>
        <h2 className={styles.logo}>
          <Link href={environment.basePath}>Blog</Link>
        </h2>
        <form
          className={styles.rowSearch}
          method="GET"
          ref={toggleSearch}
          onSubmit={handleSubmit}
          aria-label="Pesquisa"
          role="search"
        >
          <div>
            <input
              type="text"
              className={styles.search}
              autoComplete="off"
              name="s"
              value={searchData}
              onChange={(event) => setSearchData(event.target.value)}
              placeholder="Pesquisar"
            />
            <button
              type="submit"
              className={styles.btnSearch}
              aria-label="Enviar pesquisa"
            >
              <Search />
            </button>
          </div>
        </form>
        <div>
          <button
            id={styles.menuIcon}
            className={styles.normalizeBtn}
            onClick={() => {
              !navExpand ? setNavExpand(true) : setNavExpand(false);
            }}
          >
            Categorias
          </button>
          <nav
            className={[styles.navbar, navExpand && styles.expand].join(" ")}
          >
            <ul className={styles.menu}>
              {items.length > 0 &&
                items.map((item) => {
                  return (
                    <li key={item.databaseId}>
                      <Link
                        href={`${environment.basePath}/category/${item.slug}/`}
                      >
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </nav>
        </div>
        {!mobileSearch ? (
          <button
            className={[styles.mobileSearch, styles.normalizeBtn].join(" ")}
            aria-label="Abrir pesquisar"
            onClick={() => {
              toogleSearchInput();
            }}
          >
            <Search />
          </button>
        ) : (
          <button
            className={[
              styles.mobileSearch,
              styles.normalizeBtn,
              styles.closeButton,
            ].join(" ")}
            aria-label="Fechar a Pesquisa"
            onClick={() => {
              toogleSearchInput();
            }}
          >
            X
          </button>
        )}
      </div>
    </header>
  );
};
